import { render, staticRenderFns } from "./backup-file-preview-dialog.component.vue?vue&type=template&id=32043e03"
import script from "./backup-file-preview-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-file-preview-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32043e03')) {
      api.createRecord('32043e03', component.options)
    } else {
      api.reload('32043e03', component.options)
    }
    module.hot.accept("./backup-file-preview-dialog.component.vue?vue&type=template&id=32043e03", function () {
      api.rerender('32043e03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/backup-settings/backup-file-preview-dialog.component.vue"
export default component.exports